import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './SdoAdminReportDetailAvailability.scss';
import { Link } from 'react-router-dom';
import { useSdoAdminReportsProvider } from '../../providers/SdoAdminReportsProvider';
import { useEffect, useState } from 'react';
import { SdoPositionPublishObj } from '../../models/SdoInterface';
import { months } from '../../constants/dates';
import AcDialog from '../AcDialog/AcDialog';
import { getDateAndTimeFormat } from '../../helpers/dateHelpers';
import { sdoCycleStatus } from './SdoAdminReportHelper';
import { useSdoAdminEligibilityCriteriaProvider } from '../../providers/SdoAdminEligibilityCriteriaProvider';

export default function SdoAdminReportDetailAvailability({
  sdoReqList,
  isAllPositions,
  setPublished,
  setExported,
  setSdoReqListLoading,
  sdoReqListObject,
  setSdoReqListObject,
  manualAction,
  status,
  allPositionPublished,
  availabilityUpdatedByOther,
  positionsPublishData,
  setPositionsPublishData,
  position,
  setPosition,
  setAllPositionPublished
}) {
  const { t } = useTranslation();
  const sdoAdminReportsContext = useSdoAdminReportsProvider();
  const sdoAdminEligibilityCriteriaContext =
    useSdoAdminEligibilityCriteriaProvider();
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const handleClosePublishModal = () => setOpenPublishModal(false);
  const [sdoMonthYear, setSdoMonthYear] = useState<any>({
    sdoMonth: '',
    sdoYear: '',
    sdoMonthYearString: ''
  });

  const [publishFlag, setPublishFlag] = useState(false);

  useEffect(() => {
    if (!positionsPublishData?.totalPending && !positionsPublishData?.positions)
      return;

    // setPositionsPublishData(sdoAdminReportsContext.sdoPositionsPublishData);
    setPublishFlag(false);
    setSdoMonthYear({
      sdoMonth: positionsPublishData?.sdoMonth,
      sdoYear: positionsPublishData?.sdoYear,
      sdoMonthYearString:
        months[Number(positionsPublishData?.sdoMonth) - 1] +
        ' ' +
        positionsPublishData?.sdoYear
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [positionsPublishData]);

  useEffect(() => {
    if (!availabilityUpdatedByOther && publishFlag) {
      publishReport();
      setPublishFlag(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availabilityUpdatedByOther, publishFlag]);

  useEffect(() => {
    // after publishing called -->
    if (sdoAdminReportsContext.publishReportData?.message === 'success') {
      if (sdoReqListObject) {
        setSdoReqListObject({
          ...sdoReqListObject,
          status: 'PUBLISHED'
        });

        let positions;

        if (isAllPositions) {
          positions = positionsPublishData?.positions?.map((position) => {
            return {
              ...position,
              status: 'PUBLISHED',
              publishedBy:
                sdoAdminReportsContext.publishReportData?.publishedBy,
              publishedOn: sdoAdminReportsContext.publishReportData?.publishedOn
            };
          });
        } else {
          positions = positionsPublishData?.positions?.map((position) => {
            if (
              position?.pos?.base === sdoReqListObject?.base &&
              position?.pos?.equipment === sdoReqListObject?.equipment &&
              position?.pos?.position === sdoReqListObject?.position
            ) {
              return {
                ...position,
                status: 'PUBLISHED',
                publishedBy:
                  sdoAdminReportsContext.publishReportData?.publishedBy,
                publishedOn:
                  sdoAdminReportsContext.publishReportData?.publishedOn
              };
            } else {
              return {
                ...position
              };
            }
          });
        }

        const updatedPositionPublishData = {
          ...positionsPublishData,
          positions: [...positions],
          totalPublished: isAllPositions
            ? positionsPublishData.totalPending
            : positionsPublishData.totalPublished + 1,
          totalPending: isAllPositions
            ? 0
            : positionsPublishData.totalPending > 0
              ? positionsPublishData.totalPending - 1
              : 0
        };
        setPositionsPublishData(updatedPositionPublishData);

        // set position state here
        let position;
        if (!isAllPositions) {
          position = positionsPublishData?.positions?.filter(
            (position) =>
              position?.pos?.base === sdoReqListObject?.base &&
              position?.pos?.equipment === sdoReqListObject?.equipment &&
              position?.pos?.position === sdoReqListObject?.position
          )[0];
        }

        setPosition({
          ...position,
          status: 'PUBLISHED',
          publishedBy: sdoAdminReportsContext.publishReportData?.publishedBy,
          publishedOn: sdoAdminReportsContext.publishReportData?.publishedOn
        });

        setTimeout(() => {
          setPublished(true);
        }, 500);

        if (isAllPositions) {
          setAllPositionPublished(true);
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdoAdminReportsContext.publishReportData]);

  const publishReport = async () => {
    // to show loader when fetching requests for a position
    setSdoReqListLoading(true);
    const sdoPublishObj: SdoPositionPublishObj = {
      sdoMonth: sdoReqListObject.month,
      sdoYear: sdoReqListObject.year,
      base: sdoReqListObject.base,
      equipment: sdoReqListObject.equipment,
      position: sdoReqListObject.position,
      publishedOn: getDateAndTimeFormat()
    };
    await sdoAdminReportsContext.publishSdoReport(sdoPublishObj);
    setSdoReqListLoading(false);
  };

  const checkLimitsAPI = async () => {
    const position = {
      base: sdoReqListObject?.base,
      equipment: sdoReqListObject?.equipment,
      rank: sdoReqListObject?.position
    };
    await sdoAdminEligibilityCriteriaContext.viewPosition(
      position,
      sdoMonthYear
    );
    setPublishFlag(true);
  };

  const checkIfPublishPossible = () => {
    setOpen(false);
    setOpenPublishModal(false);
    checkLimitsAPI();
  };

  const onClickExportPublish = async () => {
    if (
      isAllPositions
        ? !allPositionPublished
        : sdoReqListObject?.status !== 'PUBLISHED'
    ) {
      if (manualAction && !isAllPositions) {
        setOpen(true);
      } else {
        if (!isAllPositions) setOpenPublishModal(true);
        else setOpenPublishModal(true);
      }
    } else {
      // make api call
      await sdoAdminReportsContext.getSdoMonthlyReportsData({
        month: sdoMonthYear.sdoMonth,
        year: sdoMonthYear.sdoYear
      });
    }
  };

  const publishData = {
    title: t('specialDayOff.sdoReport.publishDecisionTitle'),
    description: `${t('specialDayOff.sdoReport.publishDecisionDescription')}
        ${months[Number(sdoAdminReportsContext?.sdoPositionsPublishData?.sdoMonth) - 1] + ' ' + sdoAdminReportsContext?.sdoPositionsPublishData?.sdoYear}  ${'-'}
        <b> ${sdoReqListObject?.base} | ${sdoReqListObject?.equipment} | ${sdoReqListObject?.position}</b> ${'.'}`,
    actionLabel: t('specialDayOff.sdoReport.cancel'),
    handleAction: handleClose,
    secondaryActionLabel: t('specialDayOff.sdoReport.publish'),
    handleSecondaryAction: checkIfPublishPossible
  };

  const publishModalConfirmationData = {
    title: t('specialDayOff.sdoReport.publishConfirmationTitle'),
    description: t('specialDayOff.sdoReport.publishConfDescr', {
      monthYear: sdoMonthYear.sdoMonthYearString,
      position: `${sdoReqListObject?.base} | ${sdoReqListObject?.equipment} | ${sdoReqListObject?.position}`
    }),
    actionLabel: t('specialDayOff.sdoReport.cancel'),
    handleAction: handleClosePublishModal,
    secondaryActionLabel: t('specialDayOff.sdoReport.publish'),
    handleSecondaryAction: checkIfPublishPossible
  };

  const getPendingDeclineLabel = (approveFlag) => {
    if (approveFlag) {
      if (
        (sdoReqListObject?.status &&
          sdoReqListObject?.status === 'PUBLISHED') ||
        allPositionPublished
      ) {
        return t(
          'specialDayOffAdmin.specialDayOffAdminReportDetails.approvals'
        );
      } else {
        return t(
          'specialDayOffAdmin.specialDayOffAdminReportDetails.pendingApprovals'
        );
      }
    } else {
      if (
        (sdoReqListObject?.status &&
          sdoReqListObject?.status === 'PUBLISHED') ||
        allPositionPublished
      ) {
        return t('specialDayOffAdmin.specialDayOffAdminReportDetails.declines');
      } else {
        return t(
          'specialDayOffAdmin.specialDayOffAdminReportDetails.pendingDeclines'
        );
      }
    }
  };

  const getTotalRequestLabel = (total) => {
    if (total > 1) {
      if (
        (sdoReqListObject?.status &&
          sdoReqListObject?.status === 'PUBLISHED') ||
        allPositionPublished
      ) {
        return t(
          'specialDayOffAdmin.specialDayOffAdminReportDetails.totalRequestAfterPublish',
          { count: sdoReqList?.total }
        );
      } else {
        return t(
          'specialDayOffAdmin.specialDayOffAdminReportDetails.totalRequests',
          { count: sdoReqList?.total }
        );
      }
    } else {
      if (
        (sdoReqListObject?.status &&
          sdoReqListObject?.status === 'PUBLISHED') ||
        allPositionPublished
      ) {
        return t(
          'specialDayOffAdmin.specialDayOffAdminReportDetails.totalRequestBeforePublish',
          { count: sdoReqList?.total }
        );
      } else {
        return t(
          'specialDayOffAdmin.specialDayOffAdminReportDetails.totalRequest',
          { count: sdoReqList?.total }
        );
      }
    }
  };

  return (
    <div className="sdo-report-review__availability">
      <div className="sdo-report-review__availability-availability">
        <p className="sdo-report-review__availability-header">
          {t('specialDayOffAdmin.specialDayOffAdminReportDetails.availability')}
          <Link
            to={{ pathname: '/sdo-admin-ec', state: { setLimitTabZero: 0, pos: sdoReqListObject } }}
            className="sdo-report-review__availability-edit"
          >
            <span>
              {t('specialDayOffAdmin.specialDayOffAdminReportDetails.edit')}
            </span>
          </Link>
        </p>
        <p className="sdo-report-review__availability-info">
          {t(
            'specialDayOffAdmin.specialDayOffAdminReportDetails.requestPerDay'
          )}
          <span>{sdoReqList?.averageRequestPerDay ?? 0}</span>
        </p>
        <p className="sdo-report-review__availability-info">
          {t('specialDayOffAdmin.specialDayOffAdminReportDetails.sdoPerDay')}
          <span>{sdoReqList?.sdoAvailablePerDay ?? 0}</span>
        </p>
      </div>
      <div className="sdo-report-review__availability-recom">
        <p className="sdo-report-review__recom-header">
          {t('specialDayOffAdmin.specialDayOffAdminReportDetails.overview')}
        </p>
        <div className="sdo-report-review__recom__pending-approval">
          <span className="sdo-report-review__recom__pending-approval-style"></span>
          <p>
            {' '}
            {getPendingDeclineLabel(true)}{' '}
            <span>
              {' '}
              {sdoReqList?.pendingApprovals ?? 0}{' '}
              {sdoReqList?.pendingApprovals > 1
                ? t(
                    'specialDayOffAdmin.specialDayOffAdminReportDetails.request'
                  )
                : t(
                    'specialDayOffAdmin.specialDayOffAdminReportDetails.requests'
                  )}
            </span>{' '}
          </p>
        </div>
        <div className="sdo-report-review__recom__pending-decline">
          <span className="sdo-report-review__recom__pending-decline-style"></span>
          <p>
            {' '}
            {getPendingDeclineLabel(false)}{' '}
            <span>
              {sdoReqList?.pendingDecline ?? 0}{' '}
              {sdoReqList?.pendingDecline > 1
                ? t(
                    'specialDayOffAdmin.specialDayOffAdminReportDetails.request'
                  )
                : t(
                    'specialDayOffAdmin.specialDayOffAdminReportDetails.requests'
                  )}{' '}
            </span>
          </p>
        </div>
        {(sdoReqListObject?.status &&
          sdoReqListObject?.status === 'PUBLISHED') ||
        allPositionPublished ? (
          <div className="sdo-report-review__recom__revoked">
            <span className="sdo-report-review__recom__revoked-style"></span>
            <p>
              {' '}
              {t(
                'specialDayOffAdmin.specialDayOffAdminReportDetails.revoked'
              )}{' '}
              <span>
                {sdoReqList?.revoked ?? 0}{' '}
                {sdoReqList?.revoked > 1
                  ? t(
                      'specialDayOffAdmin.specialDayOffAdminReportDetails.request'
                    )
                  : t(
                      'specialDayOffAdmin.specialDayOffAdminReportDetails.requests'
                    )}
              </span>
            </p>
          </div>
        ) : (
          ''
        )}
        <div className="sdo-report-review__recom__total-request">
          <p>
            {' '}
            {t('specialDayOffAdmin.specialDayOffAdminReportDetails.total')}
            <span> {getTotalRequestLabel(sdoReqList?.total)} </span>{' '}
          </p>
        </div>
      </div>

      <div className="sdo-report-review__availability-export">
        <p className="sdo-report-review__export-header">
          {!allPositionPublished
            ? !isAllPositions && sdoReqListObject?.status === 'PUBLISHED'
              ? t(
                  'specialDayOffAdmin.specialDayOffAdminReportDetails.exportDecision',
                  { monthYear: sdoMonthYear.sdoMonthYearString }
                )
              : t(
                  'specialDayOffAdmin.specialDayOffAdminReportDetails.publishDecision'
                )
            : t(
                'specialDayOffAdmin.specialDayOffAdminReportDetails.exportDecision',
                { monthYear: sdoMonthYear.sdoMonthYearString }
              )}
        </p>
        <p className="sdo-report-review__export-info">
          {!allPositionPublished
            ? !isAllPositions && sdoReqListObject?.status === 'PUBLISHED'
              ? t(
                  'specialDayOffAdmin.specialDayOffAdminReportDetails.exportDecisionInfo3'
                )
              : t(
                  'specialDayOffAdmin.specialDayOffAdminReportDetails.publishInfo'
                )
            : t(
                'specialDayOffAdmin.specialDayOffAdminReportDetails.exportDecisionInfo1'
              )}
        </p>
        {allPositionPublished || sdoReqListObject?.status === 'PUBLISHED' ? (
          <p className="sdo-report-review__export-info-1">
            {t(
              'specialDayOffAdmin.specialDayOffAdminReportDetails.exportDecisionInfo2'
            )}
          </p>
        ) : (
          ''
        )}

        {!isAllPositions &&
        sdoReqListObject?.status === 'PUBLISHED' &&
        !allPositionPublished ? (
          ''
        ) : (
          <Button
            variant="outlined"
            className={
              status && status === sdoCycleStatus.OPEN
                ? 'sdo-report-review__export-button--disabled'
                : 'sdo-report-review__export-button'
            }
            onClick={() => onClickExportPublish()}
            disabled={status && status === sdoCycleStatus.OPEN ? true : false}
          >
            {!allPositionPublished
              ? !isAllPositions
                ? t(
                    'specialDayOffAdmin.specialDayOffAdminReportDetails.acceptAndPublish'
                  )
                : t(
                    'specialDayOffAdmin.specialDayOffAdminReportDetails.publishAllReports'
                  )
              : t(
                  'specialDayOffAdmin.specialDayOffAdminReportDetails.exportFile'
                )}
          </Button>
        )}
        <AcDialog open={open} onClose={handleClose} data={publishData} />
        <AcDialog
          open={openPublishModal}
          onClose={handleClosePublishModal}
          data={publishModalConfirmationData}
        />
      </div>
    </div>
  );
}
